import { useMutation } from '@tanstack/react-query';

import { login } from './auth.requests';

export const useLogin = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      login(email, password),
  });

  return { login: mutateAsync, isPending };
};
